import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faEyeSlash,
  faEnvelope,
  faLock,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import Alert from "../ui/Alert";
import PunarLogoDark from "../../assets/logos/Punar_white_mode.png";
import PunarLogoWhite from "../../assets/logos/Punar_dark_mode.png";
import "../../style/Login.css";

const LoginForm = ({
  darkMode,
  email,
  setEmail,
  password,
  setPassword,
  passwordVisible,
  setPasswordVisible,
  loading,
  loginSuccess,
  show2FA,
  isInvalid,
  errorMessage,
  handleSubmit,
  t,
}) => {
  const [focusedField, setFocusedField] = useState(null);

  const toggleVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div
      className={`login-form-container ${
        darkMode ? "dark-mode" : "light-mode"
      }`}
    >
      <div className="login-bg-decoration">
        <div className="login-bg-circle login-bg-circle--1"></div>
        <div className="login-bg-circle login-bg-circle--2"></div>
        <div className="login-bg-circle login-bg-circle--3"></div>
      </div>

      <div className="login-form-content">
        <div className="login-logo-section">
          <img
            src={darkMode ? PunarLogoWhite : PunarLogoDark}
            alt="Punar Logo"
            className="login-logo"
          />
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div
            className={`login-input-group ${
              focusedField === "email" ? "focused" : ""
            } ${email ? "has-value" : ""}`}
          >
            <div className="login-input-icon">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>
            <div className="login-input-wrapper">
              <label htmlFor="email-input" className="login-label">
                {t("Email or Username")}
              </label>
              <input
                type="text"
                id="email-input"
                className="login-input"
                placeholder={t("Enter email or username")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setFocusedField("email")}
                onBlur={() => setFocusedField(null)}
                autoComplete="username"
              />
            </div>
          </div>

          <div
            className={`login-input-group ${
              focusedField === "password" ? "focused" : ""
            } ${password ? "has-value" : ""}`}
          >
            <div className="login-input-icon">
              <FontAwesomeIcon icon={faLock} />
            </div>
            <div className="login-input-wrapper">
              <label htmlFor="password-input" className="login-label">
                {t("Password")}
              </label>
              <input
                type={passwordVisible ? "text" : "password"}
                id="password-input"
                className="login-input"
                placeholder={t("Enter your password")}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setFocusedField("password")}
                onBlur={() => setFocusedField(null)}
                autoComplete="current-password"
              />
            </div>
            <button
              type="button"
              className="login-toggle-password"
              onClick={toggleVisibility}
              aria-label={passwordVisible ? "Hide password" : "Show password"}
            >
              <FontAwesomeIcon icon={passwordVisible ? faEyeSlash : faEye} />
            </button>
          </div>

          {isInvalid && (
            <Alert message={errorMessage} severity="error" compact />
          )}

          <button
            type="submit"
            className={`login-submit-btn ${loginSuccess ? "success" : ""} ${
              loading ? "loading" : ""
            }`}
            disabled={loading || show2FA || !email || !password}
          >
            <span className="login-submit-text">
              {loginSuccess
                ? t("Success!")
                : loading
                ? t("Signing in...")
                : t("Sign In")}
            </span>
            {!loading && !loginSuccess && (
              <FontAwesomeIcon
                icon={faArrowRight}
                className="login-submit-icon"
              />
            )}
            {loading && !loginSuccess && <div className="login-spinner"></div>}
          </button>
        </form>

        <div className="login-footer">
          <p className="login-register-text">
            {t("Don't have an account?")}{" "}
            <button
              type="button"
              className="login-register-link"
              onClick={() => alert("Registration coming soon!")}
            >
              {t("Register")}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
